// Foundations
import { Component, OnInit } from '@angular/core';

// rxjs
import { Observable } from 'rxjs';
import { finalize, map } from 'rxjs/operators';

// Services
import { LoadingIndicatorService } from 'src/app/services/loading-indicator.service';
import {
  CamperCampingQuizQuestionOption,
  GetCamperCampingQuizQuestionGQL,
} from '../../../services/graphql.service';

@Component({
  selector: 'app-begin-page',
  templateUrl: './begin-page.component.html',
  styleUrls: ['./begin-page.component.scss'],
})
export class BeginPageComponent implements OnInit {
  questions$: Observable<CamperCampingQuizQuestionOption[]>;
  selectedOptions: number[] = [];

  constructor(
    private loadingIndicatorService: LoadingIndicatorService,
    private getQuizQuestionQuery: GetCamperCampingQuizQuestionGQL
  ) {}

  // Life cycles
  // ------------------------------------------------------------------------------------

  ngOnInit(): void {
    this.fetchData();
  }

  // Public Methods
  // ------------------------------------------------------------------------------------

  get isValid(): boolean {
    return this.selectedOptions.length > 0;
  }

  selectOption(id: string): void {
    const optId = +id;
    // if our list includes id we remove it, if not add it
    if (this.selectedOptions.includes(optId)) {
      const index = this.selectedOptions.indexOf(optId);
      if (index !== -1) {
        this.selectedOptions.splice(index, 1);
      }
    } else {
      this.selectedOptions.push(optId);
    }
  }

  // Private Methods
  // ------------------------------------------------------------------------------------

  private fetchData(): void {
    this.loadingIndicatorService.show();
    this.questions$ = this.getQuizQuestionQuery.fetch().pipe(
      map((res) => res.data.getCamperCampingQuizQuestion.options),
      finalize(() => this.loadingIndicatorService.hide())
    );
  }
}
